import { render, staticRenderFns } from "./imager.vue?vue&type=template&id=f6c111d8&scoped=true"
import script from "./imager.vue?vue&type=script&lang=js"
export * from "./imager.vue?vue&type=script&lang=js"
import style0 from "./imager.vue?vue&type=style&index=0&id=f6c111d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c111d8",
  null
  
)

export default component.exports